// extracted by mini-css-extract-plugin
export var anchorList = "page-header-module--anchorList--2cc7e";
export var colAnchors = "page-header-module--colAnchors--d27ce";
export var colMain = "page-header-module--colMain--768b7";
export var desc = "page-header-module--desc--d8ad4";
export var root = "page-header-module--root--efec5";
export var title = "page-header-module--title--e200a";